import { render, staticRenderFns } from "./UIButton.vue?vue&type=template&id=1b1210dc&scoped=true"
import script from "./UIButton.vue?vue&type=script&lang=js"
export * from "./UIButton.vue?vue&type=script&lang=js"
import style0 from "./UIButton.vue?vue&type=style&index=0&id=1b1210dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1210dc",
  null
  
)

export default component.exports